<ng-container *ngIf="sanitizedVideoUrl">
  <iframe [src]="sanitizedVideoUrl" class="w-full h-[40vh] md:h-[70vh]" frameborder="0" allowfullscreen></iframe>
  <div class="flex flex-row justify-center pt-4">
    <tandem-button color="primary" theme="outline" [onClick]="close.bind(this)">Close</tandem-button>
  </div>
</ng-container>
<div *ngIf="!sanitizedVideoUrl" class="w-full flex justify-center">
  <tandem-loading-container [isLoaded]="!sanitizedVideoUrl"></tandem-loading-container>
</div>
